import OnlineCondolenceCollection from '../components/OnlineCondolence/OnlineCondolenceCollection';

const OverviewPage = () => {
  return (
    <>
      <OnlineCondolenceCollection/>
    </>
  )
}

export default OverviewPage;